import { IlsModelService } from '../../services/ils-model.service'
import {
  BaseNextlabMessageHandler,
  BaseStorageService,
  IlsJsonCreatorService,
  ReportService,
} from '@monorepo/angular-common'
import { SendLogActionService } from '../../services/send-log-action.service'
import { ImagesService, LlmService, LogActionService, ProxyService } from '@monorepo/golab-generated'
import { json } from '@monorepo/next-lab'

export class NextlabMessageHandler extends BaseNextlabMessageHandler {
  constructor(
    nextlabMessagePort: MessagePort,
    storageService: BaseStorageService,
    ilsModelService: IlsModelService,
    logActionService: LogActionService,
    private readonly sendLogActionService: SendLogActionService,
    proxyService: ProxyService,
    llmService: LlmService,
    ilsJsonCreatorService: IlsJsonCreatorService,
    imagesService: ImagesService,
    reportService: ReportService,
    iframe: HTMLIFrameElement,
  ) {
    super(
      nextlabMessagePort,
      storageService,
      ilsModelService,
      logActionService,
      proxyService,
      llmService,
      ilsJsonCreatorService,
      imagesService,
      reportService,
      iframe,
      true,
    )
  }

  protected override handleLogActionMessage(actionMessage: json) {
    super.handleLogActionMessage(actionMessage)
    this.sendLogActionService.sendLogAction(actionMessage)
  }
}
